import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDotsHorizontal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8333 10C10.8333 9.5398 10.4602 9.16671 9.99998 9.16671C9.53974 9.16671 9.16665 9.5398 9.16665 10C9.16665 10.4603 9.53974 10.8334 9.99998 10.8334C10.4602 10.8334 10.8333 10.4603 10.8333 10Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.99998 10C4.99998 9.5398 4.62688 9.16671 4.16665 9.16671C3.70641 9.16671 3.33331 9.5398 3.33331 10C3.33331 10.4603 3.70641 10.8334 4.16665 10.8334C4.62688 10.8334 4.99998 10.4603 4.99998 10Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6666 10C16.6666 9.5398 16.2936 9.16671 15.8333 9.16671C15.3731 9.16671 15 9.5398 15 10C15 10.4603 15.3731 10.8334 15.8333 10.8334C16.2936 10.8334 16.6666 10.4603 16.6666 10Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8333 10C10.8333 9.5398 10.4602 9.16671 9.99998 9.16671C9.53974 9.16671 9.16665 9.5398 9.16665 10C9.16665 10.4603 9.53974 10.8334 9.99998 10.8334C10.4602 10.8334 10.8333 10.4603 10.8333 10Z",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.99998 10C4.99998 9.5398 4.62688 9.16671 4.16665 9.16671C3.70641 9.16671 3.33331 9.5398 3.33331 10C3.33331 10.4603 3.70641 10.8334 4.16665 10.8334C4.62688 10.8334 4.99998 10.4603 4.99998 10Z",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6666 10C16.6666 9.5398 16.2936 9.16671 15.8333 9.16671C15.3731 9.16671 15 9.5398 15 10C15 10.4603 15.3731 10.8334 15.8333 10.8334C16.2936 10.8334 16.6666 10.4603 16.6666 10Z",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconDotsHorizontal;
